import { useCallback } from 'react';

type UseWhitespaceShowWhitespacesParams = {
    setShowWhitespaces: (value: boolean) => void;
};

const useWhitespaceShowWhitespaces = ({ setShowWhitespaces }: UseWhitespaceShowWhitespacesParams) => {
    const handleShowWhitespacesChange = useCallback(
        (checked: boolean) => {
            setShowWhitespaces(checked);
        },
        [setShowWhitespaces],
    );

    return { handleShowWhitespacesChange };
};

export default useWhitespaceShowWhitespaces;
